export const filterConfig = [
  {
    id: 'nomeMotivo',
    type: 'text',
    label: 'Nome do Motivo',
    placeholder: 'Digite o nome do motivo',
  },
  {
    id: 'descricao',
    type: 'text',
    label: 'Descricao',
    placeholder: 'Digite parte da descricao',
  },
  {
    id: 'dataCriacaoInicial',
    type: 'date',
    label: 'Data Inicial',
  },
  {
    id: 'dataCriacaoFinal',
    type: 'date',
    label: 'Data Final',
  },
];
